import { render, staticRenderFns } from "./SavePlace.vue?vue&type=template&id=696105da&scoped=true"
import script from "./SavePlace.vue?vue&type=script&lang=js"
export * from "./SavePlace.vue?vue&type=script&lang=js"
import style0 from "./SavePlace.vue?vue&type=style&index=0&id=696105da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696105da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VPagination,VTextField})
